<template>

    <div class="container">
        
        <app-head :title="brand.meta_title || brand.name">
            <meta name="description" :content="brand.meta_description" v-if="brand.meta_description">
        </app-head>

        <div class="my-4">
            <h1>{{ brand.name }}</h1>
            <div v-if="brand.image">
                <img :src="brand.image" class="img-fluid" :alt="brand.name" style="max-width: 200px;" loading="lazy" />
            </div>
            <div class="lead" v-if="brand.description" v-html="brand.description">
            </div>
        </div>

        <results :total="products.meta.total" :from="products.meta.from" :to="products.meta.to" :filters="filters" />

        <product-list :products="products.data" />

        <pagination :links="products.meta.links" />

    </div>

</template>

<script>
    import Results from '@/shared/Results';
    import Pagination from '@/shared/Pagination';
    import Breadcrumbs from '@/shared/Breadcrumbs';
    import ProductList from '@/shared/ProductList';

    export default {
        props: [
            'brand',
            'products',
            'filters',
        ],
        components: {
            Results,
            Pagination,
            Breadcrumbs,
            ProductList,
        }
    }
</script>